import { render, staticRenderFns } from "./IbxDatePicker.vue?vue&type=template&id=b13737fe"
import script from "./IbxDatePicker.vue?vue&type=script&lang=js"
export * from "./IbxDatePicker.vue?vue&type=script&lang=js"
import style0 from "./IbxDatePicker.vue?vue&type=style&index=0&id=b13737fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports